module.exports = __webpack_public_path__ + "static/dx-337b8ba202d4c61a65a986ab135ed17a.jpg";